import {
  APIProvider,
  useMapsLibrary
} from '@vis.gl/react-google-maps'
import { GMAPS_API_KEY } from '../../services/gmaps'
import { useEffect, useRef, useState } from 'react'

export type Place = google.maps.places.PlaceResult

interface PlaceSelectorProps {
  onSelect: (place: Place) => void
  disabled?: boolean
}

export function PlaceSelectorComponent ({ onSelect, disabled }: PlaceSelectorProps): JSX.Element {
  return (
    <APIProvider
      apiKey={GMAPS_API_KEY}
      solutionChannel='GMP_devsite_samples_v3_rgmautocomplete'
    >
      <PlaceAutocomplete
        onSelect={onSelect}
        disabled={disabled}
      />
    </APIProvider>
  )
}

const PlaceAutocomplete = ({ onSelect, disabled }: PlaceSelectorProps): JSX.Element => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState<google.maps.places.Autocomplete | null>(null)
  const inputRef = useRef<HTMLInputElement>(null)
  const places = useMapsLibrary('places')

  useEffect(() => {
    if ((places === null) || inputRef.current == null) {
      return
    }

    const options = {
      fields: ['geometry', 'name', 'formatted_address', 'address_components']
    }

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options))
  }, [places])
  useEffect(() => {
    if (placeAutocomplete == null) return

    placeAutocomplete.addListener('place_changed', () => {
      onSelect(placeAutocomplete.getPlace())
    })
  }, [onSelect, placeAutocomplete])
  return (
    <div className='autocomplete-container'>
      <input ref={inputRef} type='text' disabled={disabled} placeholder='Introduce tu dirección' />
    </div>
  )
}
